import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {mailingList_template} from "../components/templates/mailingList_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {getBrandInfoFromVnAppZone} from "../utils/BrandHelper";
import {RESTRICTED_MAILING_LIST_EDIT_BRANDS} from "../utils/consts/brand";

declare var ko: any;
declare var page: any;

export class mailing_list extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected mailingList: mailingList_template;
    protected pagination: pagination_template;

    buildContent(): Array<Element> {
        this.mailingList = new mailingList_template("mailingList", this.viewModel, this)
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Mailing Lists");

        const brand = getBrandInfoFromVnAppZone(this.getVnAppZone());
        if (brand && RESTRICTED_MAILING_LIST_EDIT_BRANDS.indexOf(brand.shortName) !== -1) {
            this.mailingList.setEditRestricted(true);
        }

        return [this.mailingList.build()];
    }

    protected getModuleName(): string {
        return "mailing_list";
    }

    fillPage() {
        this.filterList();
    }

    protected mailingListsListReorder() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        this.filterList()
    }

    protected paginationOnPageClick() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.mailingList.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(type ='list'){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        if(type == 'config'){
            this.loadingIn(document.getElementById("sortable_list"));
        }else{
            this.loadingIn(this.mailingList.builtTemplate.children.namedItem("list-results"));
        }

        let mailReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/mailingList/get/';
        let mailReq_params: Array<Array<string>> = [];
        mailReq_params.push(["data", ko.toJSON(this.mailingList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(mailReq_url,mailReq_params, this);

        if(type == 'config'){
            this.XHRHdl.onReadyStateFunction = this.onFilterConfigRequestReturn;
        }else{
            this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        }

        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                let mailingLists = responseParsed.data;
                mailingLists.sort((a, b) => a.position - b.position);

                obj.mailingList.setMailingLists(mailingLists, obj.getBrandId());
                obj.mailingList.setSortables(mailingLists);

                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime)/1000*100)/100;
                obj.mailingList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage,execTime );

                // update the paginator
                obj.viewModel.mailingList.pagination.itemCount(responseParsed.totalCount);
            });
            obj.loadingOut(obj.mailingList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected onFilterConfigRequestReturn(req, obj){
        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                let mailingLists = responseParsed.data;
                mailingLists.sort((a, b) => a.position - b.position);

                obj.mailingList.setSortables(mailingLists);
            });
            obj.loadingOut(document.getElementById("sortable_list"));
        }
    }

    protected viewMailingList(id) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/mailing-lists/view/' + id + '/')
    }

    protected addMailingList() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/newsletter/mailing-lists/add/')
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    protected bulkSave(sortables) {

        // LOADING : starts
        this.loadingIn(document.getElementById('sortable_list'));

        let formReq_url: string = '/api/brand/'+ this.getVnAppZone().app.params.idBrand +'/mailingList/update/';

        let formReq_params: Array<Array<string>> = [];
        let subViewModel = JSON.parse(ko.toJSON(sortables));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Updated successfully!');
                    obj.mailingList.closePopUp();
                    obj.loadingOut(document.getElementById('sortable_list'));
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/newsletter/mailing-lists');
                });
            }
        });
        XHRHdl.execute();
    }
}


// WEBPACK FOOTER //
// ./js/modules/mailing_list.ts